import AppBaseScreen from "../../components/AppBaseScreen";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import {
  Box,
  Container,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { styles, theme } from "./theme";
import { Home, Info, QrCode } from "@mui/icons-material";
import AppDialog from "../../components/AppDialog";
import { useState } from "react";
import QrCodeScanner from "../../components/QrCodeScanner";
import { openQrScanner } from "../../utils/qrScanner";
import { extractEthereumAddress, findSymbol, findCurrency, validator, formatNumber, getSymbol} from "../../utils";
import AppButton from "../../components/AppButton";
import { useDispatch, useSelector } from "react-redux";
import AppScreenLoader from "../../components/AppScreenLoader";
import { useEffect } from "react";
import {
  getCurrenciesData,
  getReccuringRules,
  saveRecurringRules,
  updateRecurringRules,
} from "../../store/actions";
import { RecurringDetailCard } from "./components/RecurringDetailCard";
import {
  cryptoflow,
  ETH,
  EVENTS,
  paymentOptions,
  RECURRING_METHODS,
  USD,
} from "../../utils/constants";
import AppCurrencySelect from "../../components/AppCurrencySelect";
import { getFees, logEvent } from "../../store/api";
import { useNavigate } from "react-router-dom";
import AppToolTip from "../../components/AppTooltip";
import RecipientEntityForm from "../withdraw/components/withdraw-options/crypto-payment/ConfirmAddressOwnershipInput";
const RecurringPayment = () => {
  const currencies = useSelector(({ currencies }) => currencies.currencies);
  const symbols = useSelector(getSymbol);
  const account = useSelector(({ Auth }) => Auth?.account);
  const dashboardData = useSelector(({ dashboard }) => dashboard);
  const fiatService = dashboardData?.fiatService
  const payoutMinimumTransferable = dashboardData.payoutMinimumTransferable;

  const rules = useSelector(({ recurring }) => recurring?.rules?.[0] || null);
  const [intForm, setIntForm] = useState(0);
  const [cryptoCurrency, setCryptoCurrency] = useState({});
  const [qrcodeReader, setqrcodeReader] = useState(false);
  const [active, setActive] = useState(null);
  const [walletAddress, setWalletAddress] = useState(
    rules?.walletAddress || ""
  );
  useEffect(() => {
    if (active === 2) {
      setIntForm(0);
    }
  }, [active])
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [recipientFirstName, setRecipientFirstName] = useState(
    rules?.meta?.ownershipInfo?.recipientFirstName || ""
  );
  const [showFeeError, setShowFeeError] = useState("")
  const [recipientEntity, setRecipientEntity] = useState(
    rules?.meta?.ownershipInfo?.recipientEntity === "company" ? "1" : "0"
  );
  const [recipientLastName, setRecipientLastName] = useState(
    rules?.meta?.ownershipInfo?.recipientLastName || ""
  );
  const [ownership, setOwnership] = useState(
    rules?.meta?.ownershipInfo?.recipientEntity ? "1" : "0"
  );
  const service = useSelector(({ dashboard }) => dashboard?.fiatService);
  const [feeStructure, setFeeStructure] = useState(null);
  const handleOwnershipChange = (type) => {
    setOwnership(type);
  };

  const [customErrors, setCustomErrors] = useState({
    thresholdAmount: "",
    currency: "",
    address: "",
  });
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    const defaultCurrency = currencies?.find(
      (val) => val.currency === rules?.cryptoCurrency && val.network?.toLowerCase() === rules?.cryptoNetwork.toLowerCase()
    );
    const _currency = defaultCurrency && Object.keys(defaultCurrency).length ? defaultCurrency : {};
    setCryptoCurrency(_currency);
  }, [rules, currencies]);

  const validateForm = (data) => {
    let flag = true;
    if (!data?.thresholdAmount) {
      flag = false;
      setCustomErrors({
        ...customErrors,
        thresholdAmount: t("RequiredAmount"),
      });
    }

    if (
      parseFloat(data.thresholdAmount.toString()) < payoutMinimumTransferable
    ) {
      flag = false;
      setCustomErrors({
        ...customErrors,
        thresholdAmount: `${t("AmountEqual")} $${payoutMinimumTransferable}`,
      });
    }

    if (isNaN(Number(data.thresholdAmount.toString()))) {
      flag = false;
      setCustomErrors({
        ...customErrors,
        thresholdAmount: t("InvalidAmount"),
      });
    }

    if (!data?.cryptoCurrency) {
      flag = false;
      setCustomErrors({
        ...customErrors,
        currency: t("InvalidAmount"),
      });
    }
    if (!data?.walletAddress) {
      flag = false;
      setCustomErrors({
        ...customErrors,
        address: t("CurrencyRequired"),
      });
    }

    if (!validateAddress(data?.walletAddress)) {
      flag = false;
    }

    return flag;
  };
  const handleFormSubmit = (data) => {
    if (!validateForm(data) || loading) {
      return;
    }
    setLoading(true);
    const onSuccess = () => {
      setLoading(false);
      dispatch(getReccuringRules());
    };
    const onFailure = () => {
      setLoading(false);
    };
    const payload = {
      ...data,
      currency: USD,
      type: RECURRING_METHODS.CRYPTO,
      ownershipInfo:
        ownership === "1"
          ? {
            recipientEntity:
              recipientEntity === "1" ? "company" : "individual",
            recipientFirstName,
            recipientLastName,
          }
          : null,
    };
    if (rules) {
      dispatch(updateRecurringRules(payload, onSuccess, onFailure));
    } else {
      dispatch(saveRecurringRules(payload, onSuccess, onFailure));
    }
  };
  useEffect(() => {
    dispatch(getCurrenciesData());
    dispatch(getReccuringRules());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (rules) {
      setActive(2);
    } else setActive(1);
  }, [rules, service]);

  const handleQrData = async (value, setFieldValue) => {
    if (value) {
      setCustomErrors({
        ...customErrors,
        address: "",
      });
      if (cryptoCurrency === ETH) {
        value = extractEthereumAddress(value);
      }
      const validate = validator(value, cryptoCurrency?.currency, cryptoCurrency.network);
      if (validate) {
        setFieldValue("walletAddress", value);
        setWalletAddress(value);
        setqrcodeReader(false);
      } else {
        setCustomErrors({
          ...customErrors,
          address: t("invalidAddress"),
        });
        setqrcodeReader(false);
      }
    }
  };
  const handleAddressInput = async (ev, setFieldValue) => {
    try {
      const text = await navigator?.clipboard?.readText();
      if (!ev.target.value && text) {
        const validate = validator(text, cryptoCurrency?.currency, cryptoCurrency.network);
        if (validate) {
          setCustomErrors({
            ...customErrors,
            address: "",
          });
          setFieldValue("walletAddress", text);
          setWalletAddress(text);
        } else {
          setCustomErrors({
            ...customErrors,
            address: t("invalidAddress"),
          });
        }
      }
    } catch (err) {
      // console.log(err);
    }
  };

  const validateAddress = (address, currency = cryptoCurrency.currency) => {
    try {
      if (address) {
        const validate = validator(address, currency, cryptoCurrency.network);
        if (!validate) {
          setCustomErrors({
            ...customErrors,
            address: t("invalidAddress"),
          });
        } else {
          setCustomErrors({
            ...customErrors,
            address: "",
          });
        }

        return validate;
      }
      return false;
    } catch (err) {
      return false;
    }
  };

  const handleMoneyChange = (e) => {
    if (
      e.key !== "Backspace" &&
      !e.key.includes("Arrow") &&
      e.key !== "Delete"
    ) {
      const allowedKeys = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ".",
      ];
      if (!allowedKeys.includes(e.key)) {
        e.preventDefault();
        return;
      }
      if (!/^\d+(\.\d{0,1})?$/.test(e.target.value) && e.target.value !== "") {
        e.preventDefault();
        return;
      }
    }
  };

  const validateInput = (values) => {
    if (!values.thresholdAmount) {
      setCustomErrors({
        thresholdAmount: t("RequiredAmount"),
      })
    }
    if(!values.cryptoCurrency) {
      setCustomErrors({
        currency:  t("CurrencyRequired"),
      })
    }
    if(values.thresholdAmount && values.cryptoCurrency) {
      setIntForm(1);
    }
  }
  const handleBackToHome = () => {
    logEvent({
      current: EVENTS.RECURRING.GO_BACK_HOME,
      activity: EVENTS.RECURRING.GO_BACK_HOME,
    });
    navigate("/home");
  };
  if (!currencies || !active) {
    return <AppScreenLoader />;
  }
  const isAddressSomeoneElse = () => {
    return ownership === "1";
  };
  const handleNameChange = (e) => {
    if (e.target.name === "recipientFirstName") {
      setRecipientFirstName(e.target.value);
    }
    if (e.target.name === "recipientLastName") {
      setRecipientLastName(e.target.value);
    }
  };
  const isDisabled = () => {
    if (ownership === "1") {
      if (recipientLastName === "" || recipientFirstName === "") {
        return true;
      }
    }
    return !!customErrors.address || !!customErrors.thresholdAmount || loading || !walletAddress;
    // return isSubmitting;
  };

  const fetchFee = async (currency, values) => {
    setShowFeeError("");
    try {
      if(values.thresholdAmount && currency.currency && currency.network) {
        const data = await getFees({
          amount: values.thresholdAmount,
          cryptoCurrency: currency.currency,
          cryptoNetwork: currency.network,
          skipBalanceCheck: 1
        });
        setFeeStructure(data.result);
      }
    }catch(err) {
      setShowFeeError(t('estimateFeeError'))
    }

  };
  const renderInputFields = () => {
    return (
      <Container maxWidth="sm" sx={{ marginTop: 1 }} disableGutters>
        <Formik
          initialValues={{
            walletAddress: rules?.walletAddress || "",
            thresholdAmount: rules?.thresholdAmount || "",
            cryptoCurrency: rules?.cryptoCurrency || "",
            cryptoNetwork: rules?.cryptoNetwork || "",
          }}
          validate={(values) => {
            // Validation for thresholdAmount
            if (
              parseFloat(values.thresholdAmount.toString()) <
              payoutMinimumTransferable
            ) {
              setCustomErrors({
                ...customErrors,
                thresholdAmount: `${t("AmountEqual")} $${payoutMinimumTransferable
                  }`,
              });
            } else if (isNaN(Number(values.thresholdAmount.toString()))) {
              setCustomErrors({
                ...customErrors,
                thresholdAmount: `Invalid Amount`,
              });
            } else {
              setCustomErrors({
                ...customErrors,
                thresholdAmount: "",
              });
            }
          }}
          enableReinitialize={true}
          onSubmit={handleFormSubmit}
        >
          {({ errors, handleChange, setFieldValue, values }) => (
            <Form autoComplete="off">
              {intForm === 0 && <Box>
                <InputLabel>{t("recurring.balance")}</InputLabel>
                <OutlinedInput
                  error={!!errors["thresholdAmount"]}
                  style={styles.outlineInput}
                  startAdornment={<Typography paddingRight={2}>{findSymbol(symbols, account)}</Typography>}
                  required={true}
                  defaultValue={rules?.thresholdAmount || ""}
                  name="thresholdAmount"
                  autoComplete="off"
                  id="thresholdAmount"
                  onBlur={() => fetchFee(cryptoCurrency, values)}
                  onKeyDown={(e) => {
                    handleMoneyChange(e);
                  }}
                  onChange={handleChange}
                />
                {!!customErrors.thresholdAmount && (
                  <FormHelperText error={true}>
                    {customErrors.thresholdAmount}
                  </FormHelperText>
                )}
                <FormHelperText>
                  <Info
                    style={{
                      width: 14,
                      height: 14,
                      marginBottom: -3,
                      marginRight: 4,
                    }}
                  />
                  {t("recurring.balance1")}
                </FormHelperText>
                <InputLabel>{t("recurring.selectCrypto")}</InputLabel>
                <AppCurrencySelect
                  cryptoCurrency={cryptoCurrency}
                  setCryptoCurrency={(val) => {
                    setFieldValue("cryptoCurrency", val.currency);
                    setFieldValue("cryptoNetwork", val.network);
                    setCryptoCurrency(val);
                    setFeeStructure(null);
                    fetchFee(val, values);
                  }}
                  currencies={currencies}
                />
                {(showFeeError || (feeStructure && feeStructure?.feeEnabled)) && [cryptoflow.FLOW1, cryptoflow.FLOW2].includes(service.cryptoProvider) && <Box sx={{
                  boxShadow: '0px 0px 8px rgba(87, 87, 245, 0.14)',
                  mixBlendMode: 'screen',
                  border: '2px solid #1976d2',
                  borderRadius: 1,
                  padding: 1,
                  marginTop: 1,
                  marginBottom: 1
                }}>
                  {!showFeeError && <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography
                        color={"#F8F8F8"}
                        textTransform={"capitalize"}
                        fontSize={13}
                      >
                        {t("totalFees")}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        color={"#F8F8F8"}
                        textTransform={"capitalize"}
                        textAlign={"right"}
                        fontSize={13}
                      >
                        ~ {formatNumber(feeStructure?.totalFeeUsd)} {findCurrency(account)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        color={"#F8F8F8"}
                        textTransform={"capitalize"}
                        fontSize={13}
                      >
                        {t("Processing Fee")}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        color={"#F8F8F8"}
                        textTransform={"capitalize"}
                        textAlign={"right"}
                        fontSize={13}
                      >
                        ~ {feeStructure?.fee ? `${feeStructure?.fee} ` : ""}{" "}
                        {feeStructure?.fee ? `${findCurrency(account)}` : ""}
                        &nbsp;{feeStructure?.fee ? `+` : ""}&nbsp;
                        {parseFloat(feeStructure?.feePercent.toString())
                          ? `${feeStructure?.feePercent}%`
                          : ""}{" "}
                      </Typography>
                    </Grid>
                    {!!feeStructure?.swapFee && (
                      <Grid item xs={6}>
                        <Typography
                          color={"#F8F8F8"}
                          textTransform={"capitalize"}
                          fontSize={13}
                        >
                          {t("Swap Fee")}
                        </Typography>
                      </Grid>
                    )}
                    {!!feeStructure?.swapFee && (
                      <Grid item xs={6}>
                        <Typography
                          color={"#F8F8F8"}
                          textTransform={"capitalize"}
                          fontSize={13}
                          textAlign={"right"}
                        >
                          ~ {formatNumber(
                            feeStructure?.swapFee
                          )}{" "}
                          {findCurrency(account)}
                        </Typography>
                      </Grid>
                    )}
                    <Grid item xs={6}>
                      <Typography
                        color={"#F8F8F8"}
                        textTransform={"capitalize"}
                        fontSize={13}
                      >
                        {t("networkFee")}
                      </Typography>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography
                        color={"#F8F8F8"}
                        textTransform={"capitalize"}
                        textAlign={'right'}
                        fontSize={13}
                      >
                        ~  {formatNumber(
                          feeStructure?.localNetworkFee
                        )} {findCurrency(account)}
                      </Typography>
                    </Grid>
                  </Grid>}
                  {!!showFeeError && <Typography>{showFeeError}</Typography>}
                </Box>}
                {service.cryptoProvider === paymentOptions['type-5'] && <FormHelperText sx={{ marginTop: 1 }}>
                  <Info
                    style={{
                      width: 14,
                      height: 14,
                      marginBottom: -3,
                      marginRight: 4,
                    }}
                  />
                  {t("recurring.note0")}
                </FormHelperText>}
                <AppButton title={t("loginPage.continue")} disabled={!(values.thresholdAmount && values.cryptoCurrency)} onClick={() => validateInput(values)} />
              </Box>}

              {intForm === 1 && <Box>
                <InputLabel>{t("recurring.walletaddress")}</InputLabel>
                <OutlinedInput
                  fullWidth
                  defaultValue={rules?.walletAddress || ""}
                  type="text"
                  autoComplete={"off"}
                  id="walletAddress"
                  value={walletAddress}
                  name="walletAddress"
                  required={true}
                  onChange={(ev) => {
                    handleChange(ev);
                    setWalletAddress(ev.target.value);
                  }}
                  placeholder={t("recurring.enterwalletaddress")}
                  onFocus={(ev) => {
                    handleAddressInput(ev, setFieldValue);
                    validateAddress(ev.target.value, values.cryptoCurrency);
                  }}
                  onBlur={(ev) => {
                    validateAddress(ev.target.value)
                    validateAddress(ev.target.value, values.cryptoCurrency, cryptoCurrency.network)
                  }}
                  error={!!errors.walletAddress}
                  endAdornment={
                    <InputAdornment position="end">
                      <AppToolTip title={t("ScanQR")} arrow enterTouchDelay={0}>
                        <IconButton
                          aria-label="tracker"
                          aria-describedby="qr_code_scanner"
                          edge="end"
                          onClick={() =>
                            openQrScanner({
                              onScanned: (text) => handleQrData(text, setFieldValue),
                              onUseWeb: () => setqrcodeReader(true),
                              onError: (msg) =>
                                setCustomErrors({
                                  ...customErrors,
                                  address: msg,
                                }),
                            })
                          }
                        >
                          <QrCode
                            sx={{ color: "#F8FAFF", width: 20, height: 20 }}
                          />
                        </IconButton>
                      </AppToolTip>
                    </InputAdornment>
                  }
                  label="Address"
                />
                {!!customErrors.address && (
                  <FormHelperText error={true}>
                    {customErrors.address}
                  </FormHelperText>
                )}
                {fiatService?.travelRule && (
                  <RecipientEntityForm
                    isAddressSomeoneElse={isAddressSomeoneElse()}
                    ownership={ownership}
                    setOwnership={setOwnership}
                    setRecipientEntity={setRecipientEntity}
                    loading={loading}
                    recipientFirstName={recipientFirstName}
                    recipientLastName={recipientLastName}
                    handleNameChange={handleNameChange}
                    recipientEntity={recipientEntity}
                    handleOwnershipChange={handleOwnershipChange}
                  />
                )}

                <FormHelperText sx={{ marginTop: 2 }}>
                  <Info
                    style={{
                      width: 14,
                      height: 14,
                      marginBottom: -3,
                      marginRight: 4,
                    }}
                  />
                  {t("recurring.note1")}
                </FormHelperText>
                <FormHelperText>
                  <Info
                    style={{
                      width: 14,
                      height: 14,
                      marginBottom: -3,
                      marginRight: 4,
                    }}
                  />
                  {t("recurring.note2")}
                </FormHelperText>
                <AppButton
                  loading={loading}
                  buttontheme={"light"}
                  title={t("setup")}
                  type="submit"
                  disabled={isDisabled()}
                />
              </Box>}
              <AppDialog
                show={qrcodeReader}
                onChangeShow={setqrcodeReader}
                fullScreen
                bgColor={"#000000"}
              >
                <QrCodeScanner
                  setQrData={(val) => handleQrData(val, setFieldValue)}
                />
              </AppDialog>
            </Form>
          )}
        </Formik>
      </Container>
    );
  };
  const renderRecurringCardDetails = () => {
    return (
      <Container maxWidth="sm" sx={{ marginTop: 2 }} disableGutters>
        <RecurringDetailCard setActive={setActive} rules={rules} />
      </Container>
    );
  };


  return (
    <AppBaseScreen
      headerSubTitle1={t("recurring.transfers")}
      content={
        rules?.status === -1 || active === 1 ? t("recurring.content") : ""
      }
      navigate={true}
      navigatePath={intForm === 1 ? () => setIntForm(0) : '/home'}
      showLogo={false}
      backText={intForm === 1 ? t('back') : t('Home')}
    >
      <ThemeProvider theme={theme}>
        <Box>
          {rules?.status === 1 && active === 2 && (
            <Container
              maxWidth="sm"
              sx={{
                paddingLeft: "0 !important",
                paddingRight: "0 !important",
                marginTop: 2,
              }}
            >
              <Typography variant="subtitle1" fontSize={18} fontWeight={500}>
                {t("recurring.text1")}
              </Typography>
              <Typography variant="subtitle2" fontSize={14} marginTop={1}>
                {t("recurring.text2")}
              </Typography>
              <Typography variant="subtitle2" fontSize={14}>
                {t("recurring.text3")}
              </Typography>
            </Container>
          )}
          {active === 1 && renderInputFields()}
          {active === 2 && renderRecurringCardDetails()}
          <Container
            maxWidth="sm"
            sx={{
              paddingLeft: "0 !important",
              paddingRight: "0 !important",
              paddingBottom: 2,
            }}
          >
            {active === 2 && rules?.status === 1 && (
              <AppButton
                onClick={handleBackToHome}
                title={t("goHome")}
                sx={{
                  margin: "auto",
                  marginTop: 2,
                }}
                startIcon={<Home />}
              />
            )}
          </Container>
        </Box>
      </ThemeProvider>
    </AppBaseScreen>
  );
};
export default RecurringPayment;
